// PLANTS BERRIES
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const berriesData: PlantData[] = [
  {
    id: 'strawberry-june-bearing',
    name: 'Strawberry - June Bearing',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Large crop in June, then runners for next year. Remove flowers first year.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Earliglow', 'Allstar', 'Jewel'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-everbearing',
    name: 'Strawberry - Everbearing',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce'],
    enemies: ['tomato'],
    description: 'Crop in spring, summer, and fall. Smaller but continuous harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Seascape', 'Tristar', 'Ozark Beauty'],
    uses: ['fresh', 'continuous harvest']
  },
  {
    id: 'blueberry-highbush',
    name: 'Blueberry - Highbush',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Large, sweet berries on 6-foot bushes. Requires acidic soil.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Bluecrop', 'Jersey', 'Duke'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-red',
    name: 'Raspberry - Red',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Sweet red berries on thorny canes. Summer or everbearing varieties.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Heritage', 'Latham', 'Boyne'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blackberry-thornless',
    name: 'Blackberry - Thornless',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 36,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: ['tomato', 'potato'],
    description: 'Large, sweet blackberries without thorns. Erect or trailing varieties.',
    hardinessZones: '5-9',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Chester', 'Triple Crown', 'Apache'],
    uses: ['fresh', 'pie', 'jam']
  },
  {
    id: 'grape-concord',
    name: 'Grape - Concord',
    scientificName: 'Vitis labrusca',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry'],
    enemies: ['tomato'],
    description: 'Classic purple grape for juice and jelly. Hardy American variety.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Concord', 'Niagara', 'Catawba'],
    uses: ['juice', 'jelly', 'wine']
  },
  {
    id: 'apple-dwarf',
    name: 'Apple - Dwarf',
    scientificName: 'Malus domestica',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['chives', 'garlic'],
    enemies: ['potato'],
    description: 'Compact apple tree, 8-10 feet tall. Needs pollinator variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Rosaceae',
    varieties: ['Honeycrisp', 'Gala', 'Granny Smith'],
    uses: ['fresh', 'baking', 'cider']
  },
  {
    id: 'cherry-sour',
    name: 'Cherry - Sour',
    scientificName: 'Prunus cerasus',
    category: 'berry',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: ['tomato', 'potato'],
    description: 'Tart cherries for pie and preserves. Self-pollinating, smaller tree.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '12-15 feet',
    spread: '12-15 feet',
    family: 'Rosaceae',
    varieties: ['Montmorency', 'Morello'],
    uses: ['pie', 'preserves', 'dried']
  }
,
  {
    id: 'elderberry-york',
    name: 'Elderberry - York',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Large clusters of purple berries for syrup and wine. Needs pollinator.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['York', 'Adams'],
    uses: ['syrup', 'wine', 'immune support']
  },
  {
    id: 'gooseberry-pixwell',
    name: 'Gooseberry - Pixwell',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.5,
    companions: [],
    enemies: ['white pine'],
    description: 'Green to pink berries on thorny canes. Tart flavor for pies and jam.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Pixwell', 'Invicta'],
    uses: ['pies', 'jam', 'desserts']
  },
  {
    id: 'currant-red-lake',
    name: 'Currant - Red Lake',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 48,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.5,
    companions: [],
    enemies: ['white pine'],
    description: 'Bright red tart berries in clusters. Excellent for jelly and juice.',
    hardinessZones: '3-7',
    plantingSeason: 'spring',
    height: '3-5 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Red Lake', 'Jonkheer van Tets'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'kiwi-issai',
    name: 'Kiwi - Issai',
    scientificName: 'Actinidia arguta',
    category: 'berry',
    spacing: 96,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hardy kiwi, grape-sized with edible skin. Self-fertile variety.',
    hardinessZones: '4-8',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '10-15 feet',
    family: 'Actinidiaceae',
    varieties: ['Issai', 'Anna'],
    uses: ['fresh', 'salads', 'smoothies']
  },
  {
    id: 'persimmon-fuyu',
    name: 'Persimmon - Fuyu',
    scientificName: 'Diospyros kaki',
    category: 'berry',
    spacing: 180,
    rowSpacing: 180,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Non-astringent persimmon, eat firm like apple. Beautiful fall color.',
    hardinessZones: '7-10',
    plantingSeason: 'spring',
    height: '20-30 feet',
    spread: '20-25 feet',
    family: 'Ebenaceae',
    varieties: ['Fuyu', 'Jiro'],
    uses: ['fresh', 'drying', 'baking']
  },
  {
    id: 'pomegranate-wonderful',
    name: 'Pomegranate - Wonderful',
    scientificName: 'Punica granatum',
    category: 'berry',
    spacing: 120,
    rowSpacing: 120,
    daysToGermination: 0,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'low',
    soil: 'sandy',
    phMin: 5.5,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Large red fruit with jewel-like arils. Drought tolerant shrub.',
    hardinessZones: '7-11',
    plantingSeason: 'spring',
    height: '8-12 feet',
    spread: '8-10 feet',
    family: 'Lythraceae',
    varieties: ['Wonderful', 'Ambrosia'],
    uses: ['fresh', 'juice', 'syrup']
  }
,
  {
    id: 'strawberry-earliglow',
    name: 'Strawberry - Earliglow',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Earliglow strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Earliglow'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-allstar',
    name: 'Strawberry - Allstar',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Allstar strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Allstar'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-jewel',
    name: 'Strawberry - Jewel',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Jewel strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Jewel'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-chandler',
    name: 'Strawberry - Chandler',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Chandler strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-camarosa',
    name: 'Strawberry - Camarosa',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Camarosa strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Camarosa'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-seascape',
    name: 'Strawberry - Seascape',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Seascape strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Seascape'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-tristar',
    name: 'Strawberry - Tristar',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Tristar strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Tristar'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-ozark-beauty',
    name: 'Strawberry - Ozark Beauty',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ozark Beauty strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ozark Beauty'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-quinault',
    name: 'Strawberry - Quinault',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Quinault strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Quinault'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-fort-laramie',
    name: 'Strawberry - Fort Laramie',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Fort Laramie strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Fort Laramie'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-ogallala',
    name: 'Strawberry - Ogallala',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ogallala strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ogallala'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-redchief',
    name: 'Strawberry - Redchief',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Redchief strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Redchief'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-kent',
    name: 'Strawberry - Kent',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Kent strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Kent'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-surecrop',
    name: 'Strawberry - Surecrop',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Surecrop strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Surecrop'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-sparkle',
    name: 'Strawberry - Sparkle',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Sparkle strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Sparkle'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-lateglow',
    name: 'Strawberry - Lateglow',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Lateglow strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Lateglow'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-honeoye',
    name: 'Strawberry - Honeoye',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Honeoye strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Honeoye'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-guardian',
    name: 'Strawberry - Guardian',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Guardian strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Guardian'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-delmarvel',
    name: 'Strawberry - Delmarvel',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Delmarvel strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Delmarvel'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-annapolis',
    name: 'Strawberry - Annapolis',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Annapolis strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Annapolis'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-cavendish',
    name: 'Strawberry - Cavendish',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Cavendish strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Cavendish'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-mesabi',
    name: 'Strawberry - Mesabi',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Mesabi strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Mesabi'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-galletta',
    name: 'Strawberry - Galletta',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Galletta strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Galletta'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-ac-wendy',
    name: 'Strawberry - AC Wendy',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'AC Wendy strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['AC Wendy'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-darselect',
    name: 'Strawberry - Darselect',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Darselect strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Darselect'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-monterey',
    name: 'Strawberry - Monterey',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Monterey strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Monterey'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-san-andreas',
    name: 'Strawberry - San Andreas',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'San Andreas strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['San Andreas'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-portola',
    name: 'Strawberry - Portola',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Portola strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Portola'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-albion',
    name: 'Strawberry - Albion',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Albion strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Albion'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-mojave',
    name: 'Strawberry - Mojave',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Mojave strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Mojave'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-radiance',
    name: 'Strawberry - Radiance',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Radiance strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Radiance'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-sweet-ann',
    name: 'Strawberry - Sweet Ann',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Sweet Ann strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Sweet Ann'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-sweet-charlie',
    name: 'Strawberry - Sweet Charlie',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Sweet Charlie strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Sweet Charlie'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-festival',
    name: 'Strawberry - Festival',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Festival strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Festival'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-camino-real',
    name: 'Strawberry - Camino Real',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Camino Real strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Camino Real'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-palomar',
    name: 'Strawberry - Palomar',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Palomar strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Palomar'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-ventana',
    name: 'Strawberry - Ventana',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ventana strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ventana'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-benicia',
    name: 'Strawberry - Benicia',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Benicia strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Benicia'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-malling-centenary',
    name: 'Strawberry - Malling Centenary',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Malling Centenary strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Malling Centenary'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-murano',
    name: 'Strawberry - Murano',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Murano strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Murano'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-ruby-june',
    name: 'Strawberry - Ruby June',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ruby June strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ruby June'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-keepsake',
    name: 'Strawberry - Keepsake',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Keepsake strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Keepsake'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-loyalty',
    name: 'Strawberry - Loyalty',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Loyalty strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Loyalty'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'strawberry-faith',
    name: 'Strawberry - Faith',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Faith strawberry. Sweet berries, June-bearing or everbearing. Popular garden variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Faith'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-bluecrop',
    name: 'Blueberry - Bluecrop',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Bluecrop blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Bluecrop'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-jersey',
    name: 'Blueberry - Jersey',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Jersey blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Jersey'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-duke',
    name: 'Blueberry - Duke',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Duke blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Duke'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-patriot',
    name: 'Blueberry - Patriot',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Patriot blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Patriot'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-bluejay',
    name: 'Blueberry - Bluejay',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Bluejay blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Bluejay'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-blueray',
    name: 'Blueberry - Blueray',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Blueray blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Blueray'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-herbert',
    name: 'Blueberry - Herbert',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Herbert blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Herbert'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-rubel',
    name: 'Blueberry - Rubel',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Rubel blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Rubel'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-rancocas',
    name: 'Blueberry - Rancocas',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Rancocas blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Rancocas'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-weymouth',
    name: 'Blueberry - Weymouth',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Weymouth blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Weymouth'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-coville',
    name: 'Blueberry - Coville',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Coville blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Coville'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-berkeley',
    name: 'Blueberry - Berkeley',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Berkeley blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Berkeley'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-darrow',
    name: 'Blueberry - Darrow',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Darrow blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Darrow'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-elliott',
    name: 'Blueberry - Elliott',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Elliott blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Elliott'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-legacy',
    name: 'Blueberry - Legacy',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Legacy blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Legacy'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-liberty',
    name: 'Blueberry - Liberty',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Liberty blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Liberty'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-toro',
    name: 'Blueberry - Toro',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Toro blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Toro'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-chandler',
    name: 'Blueberry - Chandler',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Chandler blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-sunshine-blue',
    name: 'Blueberry - Sunshine Blue',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Sunshine Blue blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Sunshine Blue'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'blueberry-pink-lemonade',
    name: 'Blueberry - Pink Lemonade',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'high',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Pink Lemonade blueberry. Large sweet berries, requires acidic soil. Popular garden variety.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Ericaceae',
    varieties: ['Pink Lemonade'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-heritage',
    name: 'Raspberry - Heritage',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Heritage raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Heritage'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-latham',
    name: 'Raspberry - Latham',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Latham raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Latham'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-boyne',
    name: 'Raspberry - Boyne',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Boyne raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Boyne'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-killarney',
    name: 'Raspberry - Killarney',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Killarney raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Killarney'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-nova',
    name: 'Raspberry - Nova',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Nova raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-k-81',
    name: 'Raspberry - K-81',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'K-81 raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['K-81'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-anne',
    name: 'Raspberry - Anne',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Anne raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Anne'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-fall-gold',
    name: 'Raspberry - Fall Gold',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Fall Gold raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Fall Gold'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-goldie',
    name: 'Raspberry - Goldie',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Goldie raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Goldie'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-honey-queen',
    name: 'Raspberry - Honey Queen',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Honey Queen raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Honey Queen'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-royalty',
    name: 'Raspberry - Royalty',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Royalty raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Royalty'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-brandywine',
    name: 'Raspberry - Brandywine',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Brandywine raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Brandywine'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-jewel',
    name: 'Raspberry - Jewel',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Jewel raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Jewel'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-bristol',
    name: 'Raspberry - Bristol',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Bristol raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Bristol'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-munger',
    name: 'Raspberry - Munger',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Munger raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Munger'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-black-hawk',
    name: 'Raspberry - Black Hawk',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Black Hawk raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Black Hawk'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-jewel-black',
    name: 'Raspberry - Jewel Black',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Jewel Black raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Jewel Black'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-mac-black',
    name: 'Raspberry - Mac Black',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Mac Black raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Mac Black'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-raspberry-shortcake',
    name: 'Raspberry - Raspberry Shortcake',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Raspberry Shortcake raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Raspberry Shortcake'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'raspberry-bushel-and-berry',
    name: 'Raspberry - Bushel and Berry',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato', 'potato'],
    description: 'Bushel and Berry raspberry. Sweet-tart berries on thorny canes. Popular garden variety.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Bushel and Berry'],
    uses: ['fresh', 'jam', 'desserts']
  }
,
  {
    id: 'strawberry-earliglow',
    name: 'Strawberry - Earliglow',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Earliglow strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Earliglow'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-allstar',
    name: 'Blueberry - Allstar',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Allstar blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Allstar'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-jewel',
    name: 'Raspberry - Jewel',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jewel raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Jewel'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-chandler',
    name: 'Blackberry - Chandler',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Chandler blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-camarosa',
    name: 'Currant - Camarosa',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Camarosa currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Camarosa'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-seascape',
    name: 'Gooseberry - Seascape',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Seascape gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Seascape'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-tristar',
    name: 'Elderberry - Tristar',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Tristar elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Tristar'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-ozark-beauty',
    name: 'Strawberry - Ozark Beauty',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ozark Beauty strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ozark Beauty'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-quinault',
    name: 'Blueberry - Quinault',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Quinault blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Quinault'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-fort-laramie',
    name: 'Raspberry - Fort Laramie',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Fort Laramie raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Fort Laramie'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-ogallala',
    name: 'Blackberry - Ogallala',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ogallala blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Ogallala'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-redchief',
    name: 'Currant - Redchief',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Redchief currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Redchief'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-kent',
    name: 'Gooseberry - Kent',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Kent gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Kent'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-surecrop',
    name: 'Elderberry - Surecrop',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Surecrop elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Surecrop'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-sparkle',
    name: 'Strawberry - Sparkle',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Sparkle strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Sparkle'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-lateglow',
    name: 'Blueberry - Lateglow',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Lateglow blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Lateglow'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-honeoye',
    name: 'Raspberry - Honeoye',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Honeoye raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Honeoye'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-guardian',
    name: 'Blackberry - Guardian',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Guardian blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Guardian'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-delmarvel',
    name: 'Currant - Delmarvel',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Delmarvel currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Delmarvel'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-annapolis',
    name: 'Gooseberry - Annapolis',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Annapolis gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Annapolis'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-cavendish',
    name: 'Elderberry - Cavendish',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Cavendish elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Cavendish'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-mesabi',
    name: 'Strawberry - Mesabi',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Mesabi strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Mesabi'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-galletta',
    name: 'Blueberry - Galletta',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Galletta blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Galletta'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-ac-wendy',
    name: 'Raspberry - AC Wendy',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'AC Wendy raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['AC Wendy'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-darselect',
    name: 'Blackberry - Darselect',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Darselect blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Darselect'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-monterey',
    name: 'Currant - Monterey',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Monterey currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Monterey'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-san-andreas',
    name: 'Gooseberry - San Andreas',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'San Andreas gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['San Andreas'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-portola',
    name: 'Elderberry - Portola',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Portola elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Portola'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-albion',
    name: 'Strawberry - Albion',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Albion strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Albion'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-mojave',
    name: 'Blueberry - Mojave',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Mojave blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Mojave'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-radiance',
    name: 'Raspberry - Radiance',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Radiance raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Radiance'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-sweet-ann',
    name: 'Blackberry - Sweet Ann',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sweet Ann blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Sweet Ann'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-sweet-charlie',
    name: 'Currant - Sweet Charlie',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Sweet Charlie currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Sweet Charlie'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-festival',
    name: 'Gooseberry - Festival',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Festival gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Festival'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-camino-real',
    name: 'Elderberry - Camino Real',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Camino Real elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Camino Real'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-palomar',
    name: 'Strawberry - Palomar',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Palomar strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Palomar'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-ventana',
    name: 'Blueberry - Ventana',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Ventana blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Ventana'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-benicia',
    name: 'Raspberry - Benicia',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Benicia raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Benicia'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-malling-centenary',
    name: 'Blackberry - Malling Centenary',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Malling Centenary blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Malling Centenary'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-murano',
    name: 'Currant - Murano',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Murano currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Murano'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-ruby-june',
    name: 'Gooseberry - Ruby June',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ruby June gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ruby June'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-keepsake',
    name: 'Elderberry - Keepsake',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Keepsake elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Keepsake'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-loyalty',
    name: 'Strawberry - Loyalty',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Loyalty strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Loyalty'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-faith',
    name: 'Blueberry - Faith',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Faith blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Faith'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-bluecrop',
    name: 'Raspberry - Bluecrop',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Bluecrop raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Bluecrop'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-jersey',
    name: 'Blackberry - Jersey',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jersey blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Jersey'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-duke',
    name: 'Currant - Duke',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Duke currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Duke'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-patriot',
    name: 'Gooseberry - Patriot',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Patriot gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Patriot'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-bluejay',
    name: 'Elderberry - Bluejay',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Bluejay elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Bluejay'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-blueray',
    name: 'Strawberry - Blueray',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Blueray strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Blueray'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-herbert',
    name: 'Blueberry - Herbert',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Herbert blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Herbert'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-rubel',
    name: 'Raspberry - Rubel',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Rubel raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Rubel'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-rancocas',
    name: 'Blackberry - Rancocas',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Rancocas blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Rancocas'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-weymouth',
    name: 'Currant - Weymouth',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Weymouth currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Weymouth'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-coville',
    name: 'Gooseberry - Coville',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Coville gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Coville'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-berkeley',
    name: 'Elderberry - Berkeley',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Berkeley elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Berkeley'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-darrow',
    name: 'Strawberry - Darrow',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Darrow strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Darrow'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-elliott',
    name: 'Blueberry - Elliott',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Elliott blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Elliott'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-legacy',
    name: 'Raspberry - Legacy',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Legacy raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Legacy'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-liberty',
    name: 'Blackberry - Liberty',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Liberty blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Liberty'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-toro',
    name: 'Currant - Toro',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Toro currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Toro'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-chandler',
    name: 'Gooseberry - Chandler',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Chandler gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Chandler'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-sunshine-blue',
    name: 'Elderberry - Sunshine Blue',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sunshine Blue elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Sunshine Blue'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-pink-lemonade',
    name: 'Strawberry - Pink Lemonade',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Pink Lemonade strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Pink Lemonade'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-heritage',
    name: 'Blueberry - Heritage',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Heritage blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Heritage'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-latham',
    name: 'Raspberry - Latham',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Latham raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Latham'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-boyne',
    name: 'Blackberry - Boyne',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Boyne blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Boyne'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-killarney',
    name: 'Currant - Killarney',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Killarney currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Killarney'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-nova',
    name: 'Gooseberry - Nova',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Nova gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-k-81',
    name: 'Elderberry - K-81',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'K-81 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['K-81'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-anne',
    name: 'Strawberry - Anne',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Anne strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Anne'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-fall-gold',
    name: 'Blueberry - Fall Gold',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Fall Gold blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Fall Gold'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-goldie',
    name: 'Raspberry - Goldie',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Goldie raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Goldie'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-honey-queen',
    name: 'Blackberry - Honey Queen',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Honey Queen blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Honey Queen'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-royalty',
    name: 'Currant - Royalty',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Royalty currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Royalty'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-brandywine',
    name: 'Gooseberry - Brandywine',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Brandywine gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Brandywine'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-bristol',
    name: 'Elderberry - Bristol',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Bristol elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Bristol'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-munger',
    name: 'Strawberry - Munger',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Munger strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Munger'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-black-hawk',
    name: 'Blueberry - Black Hawk',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Black Hawk blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Black Hawk'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-jewel-black',
    name: 'Raspberry - Jewel Black',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jewel Black raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Jewel Black'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-mac-black',
    name: 'Blackberry - Mac Black',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mac Black blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Mac Black'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-raspberry-shortcake',
    name: 'Currant - Raspberry Shortcake',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Raspberry Shortcake currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Raspberry Shortcake'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-bushel-and-berry',
    name: 'Gooseberry - Bushel and Berry',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Bushel and Berry gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Bushel and Berry'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-chester',
    name: 'Elderberry - Chester',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Chester elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Chester'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-triple-crown',
    name: 'Strawberry - Triple Crown',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Triple Crown strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Triple Crown'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-apache',
    name: 'Blueberry - Apache',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Apache blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Apache'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-navaho',
    name: 'Raspberry - Navaho',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Navaho raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Navaho'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-arapaho',
    name: 'Blackberry - Arapaho',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Arapaho blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Arapaho'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-ouachita',
    name: 'Currant - Ouachita',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ouachita currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ouachita'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-natchez',
    name: 'Gooseberry - Natchez',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Natchez gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Natchez'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-von',
    name: 'Elderberry - Von',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Von elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Von'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-loch-ness',
    name: 'Strawberry - Loch Ness',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Loch Ness strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Loch Ness'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-black-satin',
    name: 'Blueberry - Black Satin',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Black Satin blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Black Satin'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-dirksen-thornless',
    name: 'Raspberry - Dirksen Thornless',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Dirksen Thornless raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Dirksen Thornless'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-hull-thornless',
    name: 'Blackberry - Hull Thornless',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hull Thornless blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Hull Thornless'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-smoothstem',
    name: 'Currant - Smoothstem',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Smoothstem currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Smoothstem'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-thornfree',
    name: 'Gooseberry - Thornfree',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Thornfree gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Thornfree'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-red-lake',
    name: 'Elderberry - Red Lake',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Red Lake elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Red Lake'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-jonkheer-van-tets',
    name: 'Strawberry - Jonkheer van Tets',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Jonkheer van Tets strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Jonkheer van Tets'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-white-imperial',
    name: 'Blueberry - White Imperial',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'White Imperial blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['White Imperial'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-consort',
    name: 'Raspberry - Consort',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Consort raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Consort'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-crusader',
    name: 'Blackberry - Crusader',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Crusader blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Crusader'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-titania',
    name: 'Currant - Titania',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Titania currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Titania'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-ben-sarek',
    name: 'Gooseberry - Ben Sarek',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ben Sarek gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ben Sarek'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-ben-connan',
    name: 'Elderberry - Ben Connan',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ben Connan elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Ben Connan'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-ben-lomond',
    name: 'Strawberry - Ben Lomond',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ben Lomond strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ben Lomond'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-pixwell',
    name: 'Blueberry - Pixwell',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Pixwell blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Pixwell'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-invicta',
    name: 'Raspberry - Invicta',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Invicta raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Invicta'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-hinnonmaki-red',
    name: 'Blackberry - Hinnonmaki Red',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hinnonmaki Red blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Hinnonmaki Red'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-hinnonmaki-yellow',
    name: 'Currant - Hinnonmaki Yellow',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Hinnonmaki Yellow currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Hinnonmaki Yellow'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-hinnonmaki-green',
    name: 'Gooseberry - Hinnonmaki Green',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Hinnonmaki Green gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Hinnonmaki Green'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-captivator',
    name: 'Elderberry - Captivator',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Captivator elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Captivator'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-jahn-prairie',
    name: 'Strawberry - Jahn Prairie',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Jahn Prairie strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Jahn Prairie'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-jeanne',
    name: 'Blueberry - Jeanne',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Jeanne blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Jeanne'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-poorman',
    name: 'Raspberry - Poorman',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Poorman raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Poorman'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-welcome',
    name: 'Blackberry - Welcome',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Welcome blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Welcome'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-york',
    name: 'Currant - York',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'York currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['York'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-adams',
    name: 'Gooseberry - Adams',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Adams gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Adams'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-johns',
    name: 'Elderberry - Johns',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Johns elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Johns'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-nova',
    name: 'Strawberry - Nova',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Nova strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-scotia',
    name: 'Blueberry - Scotia',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Scotia blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Scotia'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-victoria',
    name: 'Raspberry - Victoria',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Victoria raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Victoria'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-earliglow-2',
    name: 'Blackberry - Earliglow 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Earliglow 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Earliglow 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-allstar-2',
    name: 'Currant - Allstar 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Allstar 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Allstar 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-jewel-2',
    name: 'Gooseberry - Jewel 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Jewel 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Jewel 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-chandler-2',
    name: 'Elderberry - Chandler 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Chandler 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Chandler 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-camarosa-2',
    name: 'Strawberry - Camarosa 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Camarosa 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Camarosa 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-seascape-2',
    name: 'Blueberry - Seascape 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Seascape 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Seascape 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-tristar-2',
    name: 'Raspberry - Tristar 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Tristar 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Tristar 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-ozark-beauty-2',
    name: 'Blackberry - Ozark Beauty 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ozark Beauty 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Ozark Beauty 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-quinault-2',
    name: 'Currant - Quinault 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Quinault 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Quinault 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-fort-laramie-2',
    name: 'Gooseberry - Fort Laramie 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Fort Laramie 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Fort Laramie 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-ogallala-2',
    name: 'Elderberry - Ogallala 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ogallala 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Ogallala 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-redchief-2',
    name: 'Strawberry - Redchief 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Redchief 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Redchief 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-kent-2',
    name: 'Blueberry - Kent 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Kent 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Kent 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-surecrop-2',
    name: 'Raspberry - Surecrop 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Surecrop 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Surecrop 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-sparkle-2',
    name: 'Blackberry - Sparkle 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sparkle 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Sparkle 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-lateglow-2',
    name: 'Currant - Lateglow 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Lateglow 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Lateglow 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-honeoye-2',
    name: 'Gooseberry - Honeoye 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Honeoye 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Honeoye 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-guardian-2',
    name: 'Elderberry - Guardian 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Guardian 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Guardian 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-delmarvel-2',
    name: 'Strawberry - Delmarvel 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Delmarvel 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Delmarvel 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-annapolis-2',
    name: 'Blueberry - Annapolis 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Annapolis 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Annapolis 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-cavendish-2',
    name: 'Raspberry - Cavendish 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Cavendish 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Cavendish 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-mesabi-2',
    name: 'Blackberry - Mesabi 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mesabi 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Mesabi 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-galletta-2',
    name: 'Currant - Galletta 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Galletta 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Galletta 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-ac-wendy-2',
    name: 'Gooseberry - AC Wendy 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'AC Wendy 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['AC Wendy 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-darselect-2',
    name: 'Elderberry - Darselect 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Darselect 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Darselect 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-monterey-2',
    name: 'Strawberry - Monterey 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Monterey 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Monterey 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-san-andreas-2',
    name: 'Blueberry - San Andreas 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'San Andreas 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['San Andreas 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-portola-2',
    name: 'Raspberry - Portola 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Portola 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Portola 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-albion-2',
    name: 'Blackberry - Albion 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Albion 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Albion 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-mojave-2',
    name: 'Currant - Mojave 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Mojave 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Mojave 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-radiance-2',
    name: 'Gooseberry - Radiance 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Radiance 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Radiance 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-sweet-ann-2',
    name: 'Elderberry - Sweet Ann 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sweet Ann 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Sweet Ann 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-sweet-charlie-2',
    name: 'Strawberry - Sweet Charlie 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Sweet Charlie 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Sweet Charlie 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-festival-2',
    name: 'Blueberry - Festival 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Festival 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Festival 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-camino-real-2',
    name: 'Raspberry - Camino Real 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Camino Real 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Camino Real 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-palomar-2',
    name: 'Blackberry - Palomar 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Palomar 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Palomar 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-ventana-2',
    name: 'Currant - Ventana 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ventana 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ventana 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-benicia-2',
    name: 'Gooseberry - Benicia 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Benicia 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Benicia 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-malling-centenary-2',
    name: 'Elderberry - Malling Centenary 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Malling Centenary 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Malling Centenary 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-murano-2',
    name: 'Strawberry - Murano 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Murano 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Murano 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-ruby-june-2',
    name: 'Blueberry - Ruby June 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Ruby June 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Ruby June 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-keepsake-2',
    name: 'Raspberry - Keepsake 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Keepsake 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Keepsake 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-loyalty-2',
    name: 'Blackberry - Loyalty 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Loyalty 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Loyalty 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-faith-2',
    name: 'Currant - Faith 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Faith 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Faith 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-bluecrop-2',
    name: 'Gooseberry - Bluecrop 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Bluecrop 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Bluecrop 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-jersey-2',
    name: 'Elderberry - Jersey 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jersey 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Jersey 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-duke-2',
    name: 'Strawberry - Duke 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Duke 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Duke 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-patriot-2',
    name: 'Blueberry - Patriot 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Patriot 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Patriot 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-bluejay-2',
    name: 'Raspberry - Bluejay 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Bluejay 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Bluejay 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-blueray-2',
    name: 'Blackberry - Blueray 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Blueray 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Blueray 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-herbert-2',
    name: 'Currant - Herbert 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Herbert 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Herbert 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-rubel-2',
    name: 'Gooseberry - Rubel 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Rubel 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Rubel 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-rancocas-2',
    name: 'Elderberry - Rancocas 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Rancocas 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Rancocas 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-weymouth-2',
    name: 'Strawberry - Weymouth 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Weymouth 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Weymouth 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-coville-2',
    name: 'Blueberry - Coville 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Coville 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Coville 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-berkeley-2',
    name: 'Raspberry - Berkeley 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Berkeley 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Berkeley 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-darrow-2',
    name: 'Blackberry - Darrow 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Darrow 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Darrow 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-elliott-2',
    name: 'Currant - Elliott 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Elliott 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Elliott 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-legacy-2',
    name: 'Gooseberry - Legacy 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Legacy 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Legacy 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-liberty-2',
    name: 'Elderberry - Liberty 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Liberty 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Liberty 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-toro-2',
    name: 'Strawberry - Toro 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Toro 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Toro 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-chandler-2',
    name: 'Blueberry - Chandler 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Chandler 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Chandler 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-sunshine-blue-2',
    name: 'Raspberry - Sunshine Blue 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sunshine Blue 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sunshine Blue 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-pink-lemonade-2',
    name: 'Blackberry - Pink Lemonade 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Pink Lemonade 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Pink Lemonade 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-heritage-2',
    name: 'Currant - Heritage 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Heritage 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Heritage 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-latham-2',
    name: 'Gooseberry - Latham 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Latham 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Latham 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-boyne-2',
    name: 'Elderberry - Boyne 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Boyne 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Boyne 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-killarney-2',
    name: 'Strawberry - Killarney 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Killarney 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Killarney 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-nova-2',
    name: 'Blueberry - Nova 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Nova 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Nova 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-k-81-2',
    name: 'Raspberry - K-81 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'K-81 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['K-81 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-anne-2',
    name: 'Blackberry - Anne 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Anne 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Anne 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-fall-gold-2',
    name: 'Currant - Fall Gold 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Fall Gold 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Fall Gold 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-goldie-2',
    name: 'Gooseberry - Goldie 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Goldie 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Goldie 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-honey-queen-2',
    name: 'Elderberry - Honey Queen 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Honey Queen 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Honey Queen 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-royalty-2',
    name: 'Strawberry - Royalty 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Royalty 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Royalty 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-brandywine-2',
    name: 'Blueberry - Brandywine 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Brandywine 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Brandywine 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-bristol-2',
    name: 'Raspberry - Bristol 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Bristol 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Bristol 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-munger-2',
    name: 'Blackberry - Munger 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Munger 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Munger 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-black-hawk-2',
    name: 'Currant - Black Hawk 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Black Hawk 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Black Hawk 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-jewel-black-2',
    name: 'Gooseberry - Jewel Black 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Jewel Black 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Jewel Black 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-mac-black-2',
    name: 'Elderberry - Mac Black 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mac Black 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Mac Black 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-raspberry-shortcake-2',
    name: 'Strawberry - Raspberry Shortcake 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Raspberry Shortcake 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Raspberry Shortcake 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-bushel-and-berry-2',
    name: 'Blueberry - Bushel and Berry 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Bushel and Berry 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Bushel and Berry 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-chester-2',
    name: 'Raspberry - Chester 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Chester 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Chester 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-triple-crown-2',
    name: 'Blackberry - Triple Crown 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Triple Crown 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Triple Crown 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-apache-2',
    name: 'Currant - Apache 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Apache 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Apache 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-navaho-2',
    name: 'Gooseberry - Navaho 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Navaho 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Navaho 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-arapaho-2',
    name: 'Elderberry - Arapaho 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Arapaho 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Arapaho 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-ouachita-2',
    name: 'Strawberry - Ouachita 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ouachita 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ouachita 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-natchez-2',
    name: 'Blueberry - Natchez 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Natchez 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Natchez 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-von-2',
    name: 'Raspberry - Von 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Von 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Von 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-loch-ness-2',
    name: 'Blackberry - Loch Ness 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Loch Ness 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Loch Ness 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-black-satin-2',
    name: 'Currant - Black Satin 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Black Satin 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Black Satin 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-dirksen-thornless-2',
    name: 'Gooseberry - Dirksen Thornless 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Dirksen Thornless 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Dirksen Thornless 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-hull-thornless-2',
    name: 'Elderberry - Hull Thornless 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hull Thornless 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Hull Thornless 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-smoothstem-2',
    name: 'Strawberry - Smoothstem 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Smoothstem 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Smoothstem 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-thornfree-2',
    name: 'Blueberry - Thornfree 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Thornfree 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Thornfree 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-red-lake-2',
    name: 'Raspberry - Red Lake 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Red Lake 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Red Lake 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-jonkheer-van-tets-2',
    name: 'Blackberry - Jonkheer van Tets 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jonkheer van Tets 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Jonkheer van Tets 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-white-imperial-2',
    name: 'Currant - White Imperial 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'White Imperial 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['White Imperial 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-consort-2',
    name: 'Gooseberry - Consort 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Consort 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Consort 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-crusader-2',
    name: 'Elderberry - Crusader 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Crusader 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Crusader 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-titania-2',
    name: 'Strawberry - Titania 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Titania 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Titania 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-ben-sarek-2',
    name: 'Blueberry - Ben Sarek 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Ben Sarek 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Ben Sarek 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-ben-connan-2',
    name: 'Raspberry - Ben Connan 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ben Connan 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ben Connan 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-ben-lomond-2',
    name: 'Blackberry - Ben Lomond 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ben Lomond 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Ben Lomond 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-pixwell-2',
    name: 'Currant - Pixwell 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Pixwell 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Pixwell 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-invicta-2',
    name: 'Gooseberry - Invicta 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Invicta 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Invicta 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-hinnonmaki-red-2',
    name: 'Elderberry - Hinnonmaki Red 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hinnonmaki Red 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Hinnonmaki Red 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-hinnonmaki-yellow-2',
    name: 'Strawberry - Hinnonmaki Yellow 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Hinnonmaki Yellow 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Hinnonmaki Yellow 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-hinnonmaki-green-2',
    name: 'Blueberry - Hinnonmaki Green 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Hinnonmaki Green 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Hinnonmaki Green 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-captivator-2',
    name: 'Raspberry - Captivator 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Captivator 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Captivator 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-jahn-prairie-2',
    name: 'Blackberry - Jahn Prairie 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jahn Prairie 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Jahn Prairie 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-jeanne-2',
    name: 'Currant - Jeanne 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Jeanne 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Jeanne 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-poorman-2',
    name: 'Gooseberry - Poorman 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Poorman 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Poorman 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-welcome-2',
    name: 'Elderberry - Welcome 2',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Welcome 2 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Welcome 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-york-2',
    name: 'Strawberry - York 2',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'York 2 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['York 2'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-adams-2',
    name: 'Blueberry - Adams 2',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Adams 2 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Adams 2'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-johns-2',
    name: 'Raspberry - Johns 2',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Johns 2 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Johns 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-nova-2',
    name: 'Blackberry - Nova 2',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Nova 2 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Nova 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-scotia-2',
    name: 'Currant - Scotia 2',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Scotia 2 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Scotia 2'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-victoria-2',
    name: 'Gooseberry - Victoria 2',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Victoria 2 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Victoria 2'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-earliglow-3',
    name: 'Elderberry - Earliglow 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Earliglow 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Earliglow 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-allstar-3',
    name: 'Strawberry - Allstar 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Allstar 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Allstar 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-jewel-3',
    name: 'Blueberry - Jewel 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Jewel 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Jewel 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-chandler-3',
    name: 'Raspberry - Chandler 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Chandler 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Chandler 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-camarosa-3',
    name: 'Blackberry - Camarosa 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Camarosa 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Camarosa 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-seascape-3',
    name: 'Currant - Seascape 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Seascape 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Seascape 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-tristar-3',
    name: 'Gooseberry - Tristar 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Tristar 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Tristar 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-ozark-beauty-3',
    name: 'Elderberry - Ozark Beauty 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ozark Beauty 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Ozark Beauty 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-quinault-3',
    name: 'Strawberry - Quinault 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Quinault 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Quinault 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-fort-laramie-3',
    name: 'Blueberry - Fort Laramie 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Fort Laramie 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Fort Laramie 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-ogallala-3',
    name: 'Raspberry - Ogallala 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ogallala 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ogallala 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-redchief-3',
    name: 'Blackberry - Redchief 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Redchief 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Redchief 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-kent-3',
    name: 'Currant - Kent 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Kent 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Kent 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-surecrop-3',
    name: 'Gooseberry - Surecrop 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Surecrop 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Surecrop 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-sparkle-3',
    name: 'Elderberry - Sparkle 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sparkle 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Sparkle 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-lateglow-3',
    name: 'Strawberry - Lateglow 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Lateglow 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Lateglow 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-honeoye-3',
    name: 'Blueberry - Honeoye 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Honeoye 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Honeoye 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-guardian-3',
    name: 'Raspberry - Guardian 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Guardian 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Guardian 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-delmarvel-3',
    name: 'Blackberry - Delmarvel 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Delmarvel 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Delmarvel 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-annapolis-3',
    name: 'Currant - Annapolis 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Annapolis 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Annapolis 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-cavendish-3',
    name: 'Gooseberry - Cavendish 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Cavendish 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Cavendish 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-mesabi-3',
    name: 'Elderberry - Mesabi 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mesabi 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Mesabi 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-galletta-3',
    name: 'Strawberry - Galletta 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Galletta 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Galletta 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-ac-wendy-3',
    name: 'Blueberry - AC Wendy 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'AC Wendy 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['AC Wendy 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-darselect-3',
    name: 'Raspberry - Darselect 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Darselect 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Darselect 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-monterey-3',
    name: 'Blackberry - Monterey 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Monterey 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Monterey 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-san-andreas-3',
    name: 'Currant - San Andreas 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'San Andreas 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['San Andreas 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-portola-3',
    name: 'Gooseberry - Portola 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Portola 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Portola 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-albion-3',
    name: 'Elderberry - Albion 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Albion 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Albion 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-mojave-3',
    name: 'Strawberry - Mojave 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Mojave 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Mojave 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-radiance-3',
    name: 'Blueberry - Radiance 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Radiance 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Radiance 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-sweet-ann-3',
    name: 'Raspberry - Sweet Ann 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sweet Ann 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sweet Ann 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-sweet-charlie-3',
    name: 'Blackberry - Sweet Charlie 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sweet Charlie 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Sweet Charlie 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-festival-3',
    name: 'Currant - Festival 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Festival 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Festival 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-camino-real-3',
    name: 'Gooseberry - Camino Real 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Camino Real 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Camino Real 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-palomar-3',
    name: 'Elderberry - Palomar 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Palomar 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Palomar 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-ventana-3',
    name: 'Strawberry - Ventana 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Ventana 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Ventana 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-benicia-3',
    name: 'Blueberry - Benicia 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Benicia 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Benicia 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-malling-centenary-3',
    name: 'Raspberry - Malling Centenary 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Malling Centenary 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Malling Centenary 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-murano-3',
    name: 'Blackberry - Murano 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Murano 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Murano 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-ruby-june-3',
    name: 'Currant - Ruby June 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ruby June 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ruby June 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-keepsake-3',
    name: 'Gooseberry - Keepsake 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Keepsake 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Keepsake 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-loyalty-3',
    name: 'Elderberry - Loyalty 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Loyalty 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Loyalty 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-faith-3',
    name: 'Strawberry - Faith 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Faith 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Faith 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-bluecrop-3',
    name: 'Blueberry - Bluecrop 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Bluecrop 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Bluecrop 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-jersey-3',
    name: 'Raspberry - Jersey 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jersey 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Jersey 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-duke-3',
    name: 'Blackberry - Duke 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Duke 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Duke 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-patriot-3',
    name: 'Currant - Patriot 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Patriot 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Patriot 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-bluejay-3',
    name: 'Gooseberry - Bluejay 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Bluejay 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Bluejay 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-blueray-3',
    name: 'Elderberry - Blueray 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Blueray 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Blueray 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-herbert-3',
    name: 'Strawberry - Herbert 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Herbert 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Herbert 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-rubel-3',
    name: 'Blueberry - Rubel 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Rubel 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Rubel 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-rancocas-3',
    name: 'Raspberry - Rancocas 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Rancocas 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Rancocas 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-weymouth-3',
    name: 'Blackberry - Weymouth 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Weymouth 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Weymouth 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-coville-3',
    name: 'Currant - Coville 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Coville 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Coville 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-berkeley-3',
    name: 'Gooseberry - Berkeley 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Berkeley 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Berkeley 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-darrow-3',
    name: 'Elderberry - Darrow 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Darrow 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Darrow 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-elliott-3',
    name: 'Strawberry - Elliott 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Elliott 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Elliott 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-legacy-3',
    name: 'Blueberry - Legacy 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Legacy 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Legacy 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-liberty-3',
    name: 'Raspberry - Liberty 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Liberty 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Liberty 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-toro-3',
    name: 'Blackberry - Toro 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Toro 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Toro 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-chandler-3',
    name: 'Currant - Chandler 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Chandler 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Chandler 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-sunshine-blue-3',
    name: 'Gooseberry - Sunshine Blue 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Sunshine Blue 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Sunshine Blue 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-pink-lemonade-3',
    name: 'Elderberry - Pink Lemonade 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Pink Lemonade 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Pink Lemonade 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-heritage-3',
    name: 'Strawberry - Heritage 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Heritage 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Heritage 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-latham-3',
    name: 'Blueberry - Latham 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Latham 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Latham 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-boyne-3',
    name: 'Raspberry - Boyne 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Boyne 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Boyne 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-killarney-3',
    name: 'Blackberry - Killarney 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Killarney 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Killarney 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-nova-3',
    name: 'Currant - Nova 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Nova 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Nova 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-k-81-3',
    name: 'Gooseberry - K-81 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'K-81 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['K-81 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-anne-3',
    name: 'Elderberry - Anne 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Anne 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Anne 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-fall-gold-3',
    name: 'Strawberry - Fall Gold 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Fall Gold 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Fall Gold 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-goldie-3',
    name: 'Blueberry - Goldie 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Goldie 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Goldie 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-honey-queen-3',
    name: 'Raspberry - Honey Queen 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Honey Queen 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Honey Queen 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-royalty-3',
    name: 'Blackberry - Royalty 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Royalty 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Royalty 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-brandywine-3',
    name: 'Currant - Brandywine 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Brandywine 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Brandywine 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-bristol-3',
    name: 'Gooseberry - Bristol 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Bristol 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Bristol 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-munger-3',
    name: 'Elderberry - Munger 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Munger 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Munger 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-black-hawk-3',
    name: 'Strawberry - Black Hawk 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Black Hawk 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Black Hawk 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-jewel-black-3',
    name: 'Blueberry - Jewel Black 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Jewel Black 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Jewel Black 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-mac-black-3',
    name: 'Raspberry - Mac Black 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mac Black 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Mac Black 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-raspberry-shortcake-3',
    name: 'Blackberry - Raspberry Shortcake 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Raspberry Shortcake 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Raspberry Shortcake 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-bushel-and-berry-3',
    name: 'Currant - Bushel and Berry 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Bushel and Berry 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Bushel and Berry 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-chester-3',
    name: 'Gooseberry - Chester 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Chester 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Chester 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-triple-crown-3',
    name: 'Elderberry - Triple Crown 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Triple Crown 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Triple Crown 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-apache-3',
    name: 'Strawberry - Apache 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Apache 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Apache 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-navaho-3',
    name: 'Blueberry - Navaho 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Navaho 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Navaho 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-arapaho-3',
    name: 'Raspberry - Arapaho 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Arapaho 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Arapaho 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-ouachita-3',
    name: 'Blackberry - Ouachita 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ouachita 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Ouachita 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-natchez-3',
    name: 'Currant - Natchez 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Natchez 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Natchez 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-von-3',
    name: 'Gooseberry - Von 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Von 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Von 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-loch-ness-3',
    name: 'Elderberry - Loch Ness 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Loch Ness 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Loch Ness 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-black-satin-3',
    name: 'Strawberry - Black Satin 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Black Satin 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Black Satin 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-dirksen-thornless-3',
    name: 'Blueberry - Dirksen Thornless 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Dirksen Thornless 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Dirksen Thornless 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-hull-thornless-3',
    name: 'Raspberry - Hull Thornless 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hull Thornless 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Hull Thornless 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-smoothstem-3',
    name: 'Blackberry - Smoothstem 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Smoothstem 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Smoothstem 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-thornfree-3',
    name: 'Currant - Thornfree 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Thornfree 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Thornfree 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-red-lake-3',
    name: 'Gooseberry - Red Lake 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Red Lake 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Red Lake 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-jonkheer-van-tets-3',
    name: 'Elderberry - Jonkheer van Tets 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jonkheer van Tets 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Jonkheer van Tets 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-white-imperial-3',
    name: 'Strawberry - White Imperial 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'White Imperial 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['White Imperial 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-consort-3',
    name: 'Blueberry - Consort 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Consort 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Consort 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-crusader-3',
    name: 'Raspberry - Crusader 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Crusader 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Crusader 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-titania-3',
    name: 'Blackberry - Titania 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Titania 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Titania 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-ben-sarek-3',
    name: 'Currant - Ben Sarek 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ben Sarek 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ben Sarek 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-ben-connan-3',
    name: 'Gooseberry - Ben Connan 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ben Connan 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ben Connan 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-ben-lomond-3',
    name: 'Elderberry - Ben Lomond 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ben Lomond 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Ben Lomond 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-pixwell-3',
    name: 'Strawberry - Pixwell 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Pixwell 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Pixwell 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-invicta-3',
    name: 'Blueberry - Invicta 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Invicta 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Invicta 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-hinnonmaki-red-3',
    name: 'Raspberry - Hinnonmaki Red 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hinnonmaki Red 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Hinnonmaki Red 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-hinnonmaki-yellow-3',
    name: 'Blackberry - Hinnonmaki Yellow 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Hinnonmaki Yellow 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Hinnonmaki Yellow 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-hinnonmaki-green-3',
    name: 'Currant - Hinnonmaki Green 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Hinnonmaki Green 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Hinnonmaki Green 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-captivator-3',
    name: 'Gooseberry - Captivator 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Captivator 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Captivator 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-jahn-prairie-3',
    name: 'Elderberry - Jahn Prairie 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Jahn Prairie 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Jahn Prairie 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-jeanne-3',
    name: 'Strawberry - Jeanne 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Jeanne 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Jeanne 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-poorman-3',
    name: 'Blueberry - Poorman 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Poorman 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Poorman 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-welcome-3',
    name: 'Raspberry - Welcome 3',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Welcome 3 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Welcome 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-york-3',
    name: 'Blackberry - York 3',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'York 3 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['York 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-adams-3',
    name: 'Currant - Adams 3',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Adams 3 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Adams 3'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-johns-3',
    name: 'Gooseberry - Johns 3',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Johns 3 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Johns 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-nova-3',
    name: 'Elderberry - Nova 3',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Nova 3 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Nova 3'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-scotia-3',
    name: 'Strawberry - Scotia 3',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Scotia 3 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Scotia 3'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-victoria-3',
    name: 'Blueberry - Victoria 3',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Victoria 3 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Victoria 3'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-earliglow-4',
    name: 'Raspberry - Earliglow 4',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Earliglow 4 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Earliglow 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-allstar-4',
    name: 'Blackberry - Allstar 4',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Allstar 4 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Allstar 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-jewel-4',
    name: 'Currant - Jewel 4',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Jewel 4 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Jewel 4'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-chandler-4',
    name: 'Gooseberry - Chandler 4',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Chandler 4 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Chandler 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-camarosa-4',
    name: 'Elderberry - Camarosa 4',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Camarosa 4 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Camarosa 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-seascape-4',
    name: 'Strawberry - Seascape 4',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Seascape 4 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Seascape 4'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-tristar-4',
    name: 'Blueberry - Tristar 4',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Tristar 4 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Tristar 4'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-ozark-beauty-4',
    name: 'Raspberry - Ozark Beauty 4',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Ozark Beauty 4 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Ozark Beauty 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-quinault-4',
    name: 'Blackberry - Quinault 4',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Quinault 4 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Quinault 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-fort-laramie-4',
    name: 'Currant - Fort Laramie 4',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Fort Laramie 4 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Fort Laramie 4'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-ogallala-4',
    name: 'Gooseberry - Ogallala 4',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Ogallala 4 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Ogallala 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-redchief-4',
    name: 'Elderberry - Redchief 4',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Redchief 4 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Redchief 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-kent-4',
    name: 'Strawberry - Kent 4',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Kent 4 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Kent 4'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-surecrop-4',
    name: 'Blueberry - Surecrop 4',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Surecrop 4 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Surecrop 4'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-sparkle-4',
    name: 'Raspberry - Sparkle 4',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sparkle 4 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Sparkle 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-lateglow-4',
    name: 'Blackberry - Lateglow 4',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Lateglow 4 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Lateglow 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-honeoye-4',
    name: 'Currant - Honeoye 4',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Honeoye 4 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Honeoye 4'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-guardian-4',
    name: 'Gooseberry - Guardian 4',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Guardian 4 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Guardian 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-delmarvel-4',
    name: 'Elderberry - Delmarvel 4',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Delmarvel 4 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Delmarvel 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-annapolis-4',
    name: 'Strawberry - Annapolis 4',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Annapolis 4 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Annapolis 4'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-cavendish-4',
    name: 'Blueberry - Cavendish 4',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Cavendish 4 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Cavendish 4'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-mesabi-4',
    name: 'Raspberry - Mesabi 4',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mesabi 4 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Mesabi 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-galletta-4',
    name: 'Blackberry - Galletta 4',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Galletta 4 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Galletta 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-ac-wendy-4',
    name: 'Currant - AC Wendy 4',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'AC Wendy 4 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['AC Wendy 4'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-darselect-4',
    name: 'Gooseberry - Darselect 4',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Darselect 4 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Darselect 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-monterey-4',
    name: 'Elderberry - Monterey 4',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Monterey 4 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Monterey 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-san-andreas-4',
    name: 'Strawberry - San Andreas 4',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'San Andreas 4 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['San Andreas 4'],
    uses: ['fresh', 'jam', 'desserts']
  },
  {
    id: 'blueberry-portola-4',
    name: 'Blueberry - Portola 4',
    scientificName: 'Vaccinium corymbosum',
    category: 'berry',
    spacing: 60,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 4.5,
    phMax: 5.5,
    companions: ['strawberry'],
    enemies: ['tomato'],
    description: 'Portola 4 blueberry. Antioxidant-rich, sweet-tart flavor.',
    hardinessZones: '4-7',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '4-6 feet',
    family: 'Rosaceae',
    varieties: ['Portola 4'],
    uses: ['fresh', 'baking', 'freezing']
  },
  {
    id: 'raspberry-albion-4',
    name: 'Raspberry - Albion 4',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Albion 4 raspberry. Delicate sweet-tart berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Rosaceae',
    varieties: ['Albion 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'blackberry-mojave-4',
    name: 'Blackberry - Mojave 4',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Mojave 4 blackberry. Large sweet berries, thornless varieties available.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: 'indefinite',
    family: 'Rosaceae',
    varieties: ['Mojave 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'currant-radiance-4',
    name: 'Currant - Radiance 4',
    scientificName: 'Ribes rubrum',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Radiance 4 currant. Tart berries excellent for jelly and juice.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Radiance 4'],
    uses: ['jelly', 'juice', 'desserts']
  },
  {
    id: 'gooseberry-sweet-ann-4',
    name: 'Gooseberry - Sweet Ann 4',
    scientificName: 'Ribes uva-crispa',
    category: 'berry',
    spacing: 24,
    rowSpacing: 72,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['white pine'],
    description: 'Sweet Ann 4 gooseberry. Unique tart berries for pies and preserves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '3-4 feet',
    family: 'Grossulariaceae',
    varieties: ['Sweet Ann 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'elderberry-sweet-charlie-4',
    name: 'Elderberry - Sweet Charlie 4',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['garlic'],
    enemies: ['tomato'],
    description: 'Sweet Charlie 4 elderberry. Immune-boosting berries for syrup and wine.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '8-10 feet',
    family: 'Adoxaceae',
    varieties: ['Sweet Charlie 4'],
    uses: ['fresh', 'jam', 'desserts', 'pies']
  },
  {
    id: 'strawberry-festival-4',
    name: 'Strawberry - Festival 4',
    scientificName: 'Fragaria x ananassa',
    category: 'berry',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 0,
    daysToHarvest: 365,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['lettuce', 'spinach'],
    enemies: ['tomato', 'potato'],
    description: 'Festival 4 strawberry. Sweet berries, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '12-18 inches',
    family: 'Rosaceae',
    varieties: ['Festival 4'],
    uses: ['fresh', 'jam', 'desserts']
  }
,
  {
    id: 'grape-concord',
    name: 'Grape - Concord',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Concord'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-niagara',
    name: 'Grape - Niagara',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Niagara'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-catawba',
    name: 'Grape - Catawba',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Catawba'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-delaware',
    name: 'Grape - Delaware',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Delaware'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-isabella',
    name: 'Grape - Isabella',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Isabella'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-ives',
    name: 'Grape - Ives',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ives'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-marquette',
    name: 'Grape - Marquette',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marquette'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-frontenac',
    name: 'Grape - Frontenac',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-la-crescent',
    name: 'Grape - La Crescent',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crescent'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-st-croix',
    name: 'Grape - St Croix',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['St Croix'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-brianna',
    name: 'Grape - Brianna',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Brianna'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-edelweiss',
    name: 'Grape - Edelweiss',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Edelweiss'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-kay-gray',
    name: 'Grape - Kay Gray',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Kay Gray'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-la-crosse',
    name: 'Grape - La Crosse',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crosse'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-frontenac-gris',
    name: 'Grape - Frontenac Gris',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac Gris'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-petite-pearl',
    name: 'Grape - Petite Pearl',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Petite Pearl'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-itasca',
    name: 'Grape - Itasca',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Itasca'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-esprit',
    name: 'Grape - Esprit',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Esprit'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-swenson-red',
    name: 'Grape - Swenson Red',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Swenson Red'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-prairie-star',
    name: 'Grape - Prairie Star',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Prairie Star'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-saber',
    name: 'Grape - Saber',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saber'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-valiant',
    name: 'Grape - Valiant',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Valiant'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-beta',
    name: 'Grape - Beta',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beta'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-king-of-the-north',
    name: 'Grape - King of the North',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['King of the North'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-marechal-foch',
    name: 'Grape - Marechal Foch',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marechal Foch'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-leon-millot',
    name: 'Grape - Leon Millot',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Leon Millot'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-aurore',
    name: 'Grape - Aurore',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aurore'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-seyval-blanc',
    name: 'Grape - Seyval Blanc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Seyval Blanc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-vidal-blanc',
    name: 'Grape - Vidal Blanc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vidal Blanc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chardonel',
    name: 'Grape - Chardonel',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chardonel'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-traminette',
    name: 'Grape - Traminette',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Traminette'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-vignoles',
    name: 'Grape - Vignoles',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vignoles'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chambourcin',
    name: 'Grape - Chambourcin',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chambourcin'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-noiret',
    name: 'Grape - Noiret',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Noiret'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-corot-noir',
    name: 'Grape - Corot Noir',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Corot Noir'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-arandell',
    name: 'Grape - Arandell',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Arandell'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-aromella',
    name: 'Grape - Aromella',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aromella'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-crimson-cabernet',
    name: 'Grape - Crimson Cabernet',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Crimson Cabernet'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-jupiter',
    name: 'Grape - Jupiter',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Jupiter'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-mars',
    name: 'Grape - Mars',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Mars'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-neptune',
    name: 'Grape - Neptune',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Neptune'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-reliance',
    name: 'Grape - Reliance',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Reliance'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-saturn',
    name: 'Grape - Saturn',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saturn'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-venus',
    name: 'Grape - Venus',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Venus'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-canadice',
    name: 'Grape - Canadice',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Canadice'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-einset',
    name: 'Grape - Einset',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Einset'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-himrod',
    name: 'Grape - Himrod',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Himrod'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-interlaken',
    name: 'Grape - Interlaken',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Interlaken'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-lakemont',
    name: 'Grape - Lakemont',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Lakemont'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-suffolk-red',
    name: 'Grape - Suffolk Red',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Suffolk Red'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-vanessa',
    name: 'Grape - Vanessa',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vanessa'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-marquis',
    name: 'Grape - Marquis',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marquis'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-glenora',
    name: 'Grape - Glenora',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Glenora'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-steuben',
    name: 'Grape - Steuben',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Steuben'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-romulus',
    name: 'Grape - Romulus',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Romulus'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-fredonia',
    name: 'Grape - Fredonia',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fredonia'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-worden',
    name: 'Grape - Worden',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Worden'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-sheridan',
    name: 'Grape - Sheridan',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sheridan'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-buffalo',
    name: 'Grape - Buffalo',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Buffalo'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-clinton',
    name: 'Grape - Clinton',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Clinton'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-elvira',
    name: 'Grape - Elvira',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Elvira'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-rougeon',
    name: 'Grape - Rougeon',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Rougeon'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-de-chaunac',
    name: 'Grape - De Chaunac',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['De Chaunac'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-baco-noir',
    name: 'Grape - Baco Noir',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Baco Noir'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chelois',
    name: 'Grape - Chelois',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chelois'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chancellor',
    name: 'Grape - Chancellor',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chancellor'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-alicante-bouschet',
    name: 'Grape - Alicante Bouschet',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alicante Bouschet'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-barbera',
    name: 'Grape - Barbera',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Barbera'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-cabernet-franc',
    name: 'Grape - Cabernet Franc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Cabernet Franc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-cabernet-sauvignon',
    name: 'Grape - Cabernet Sauvignon',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Cabernet Sauvignon'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-chardonnay',
    name: 'Grape - Chardonnay',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chardonnay'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-chenin-blanc',
    name: 'Grape - Chenin Blanc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chenin Blanc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-gamay',
    name: 'Grape - Gamay',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Gamay'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-gewurztraminer',
    name: 'Grape - Gewurztraminer',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Gewurztraminer'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-grenache',
    name: 'Grape - Grenache',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Grenache'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-malbec',
    name: 'Grape - Malbec',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Malbec'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-merlot',
    name: 'Grape - Merlot',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Merlot'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-muscat',
    name: 'Grape - Muscat',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Muscat'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-petite-sirah',
    name: 'Grape - Petite Sirah',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Petite Sirah'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-pinot-blanc',
    name: 'Grape - Pinot Blanc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Blanc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-pinot-grigio',
    name: 'Grape - Pinot Grigio',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Grigio'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-pinot-noir',
    name: 'Grape - Pinot Noir',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Noir'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-riesling',
    name: 'Grape - Riesling',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Riesling'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-sangiovese',
    name: 'Grape - Sangiovese',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sangiovese'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-sauvignon-blanc',
    name: 'Grape - Sauvignon Blanc',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sauvignon Blanc'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-semillon',
    name: 'Grape - Semillon',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Semillon'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-syrah',
    name: 'Grape - Syrah',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Syrah'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-tempranillo',
    name: 'Grape - Tempranillo',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Tempranillo'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-viognier',
    name: 'Grape - Viognier',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Viognier'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-zinfandel',
    name: 'Grape - Zinfandel',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Zinfandel'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-thompson-seedless',
    name: 'Grape - Thompson Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Thompson Seedless'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-flame-seedless',
    name: 'Grape - Flame Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Flame Seedless'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-red-globe',
    name: 'Grape - Red Globe',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Red Globe'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-perlette',
    name: 'Grape - Perlette',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Perlette'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-ruby-seedless',
    name: 'Grape - Ruby Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ruby Seedless'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-black-monukka',
    name: 'Grape - Black Monukka',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Black Monukka'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-calmeria',
    name: 'Grape - Calmeria',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Calmeria'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-christmas-rose',
    name: 'Grape - Christmas Rose',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Christmas Rose'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-emperor',
    name: 'Grape - Emperor',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Emperor'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-fantasy-seedless',
    name: 'Grape - Fantasy Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fantasy Seedless'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-holiday',
    name: 'Grape - Holiday',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Holiday'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-marroo-seedless',
    name: 'Grape - Marroo Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marroo Seedless'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-midnight-beauty',
    name: 'Grape - Midnight Beauty',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Midnight Beauty'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-princess',
    name: 'Grape - Princess',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Princess'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-scarlet-royal',
    name: 'Grape - Scarlet Royal',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Scarlet Royal'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-sugraone',
    name: 'Grape - Sugraone',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sugraone'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-sultana',
    name: 'Grape - Sultana',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sultana'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-thomcord',
    name: 'Grape - Thomcord',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Thomcord'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-autumn-royal',
    name: 'Grape - Autumn Royal',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Autumn Royal'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-beauty-seedless',
    name: 'Grape - Beauty Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beauty Seedless'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-crimson-seedless',
    name: 'Grape - Crimson Seedless',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Crimson Seedless'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-fantasy',
    name: 'Grape - Fantasy',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fantasy'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-flame-tokay',
    name: 'Grape - Flame Tokay',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Flame Tokay'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-italia',
    name: 'Grape - Italia',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Italia'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-olympia',
    name: 'Grape - Olympia',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Olympia'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-ribier',
    name: 'Grape - Ribier',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ribier'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-tokay',
    name: 'Grape - Tokay',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Tokay'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-alpenglow',
    name: 'Grape - Alpenglow',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alpenglow'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-alwood',
    name: 'Grape - Alwood',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alwood'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-amber',
    name: 'Grape - Amber',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Amber'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-america',
    name: 'Grape - America',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['America'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-bath',
    name: 'Grape - Bath',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Bath'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-beacon',
    name: 'Grape - Beacon',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beacon'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-ben-hur',
    name: 'Grape - Ben Hur',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ben Hur'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-big-red',
    name: 'Grape - Big Red',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Big Red'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-concord-2',
    name: 'Grape - Concord 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Concord 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-niagara-2',
    name: 'Grape - Niagara 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Niagara 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-catawba-2',
    name: 'Grape - Catawba 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Catawba 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-delaware-2',
    name: 'Grape - Delaware 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Delaware 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-isabella-2',
    name: 'Grape - Isabella 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Isabella 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-ives-2',
    name: 'Grape - Ives 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ives 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-marquette-2',
    name: 'Grape - Marquette 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marquette 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-frontenac-2',
    name: 'Grape - Frontenac 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-la-crescent-2',
    name: 'Grape - La Crescent 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crescent 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-st-croix-2',
    name: 'Grape - St Croix 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['St Croix 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-brianna-2',
    name: 'Grape - Brianna 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Brianna 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-edelweiss-2',
    name: 'Grape - Edelweiss 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Edelweiss 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-kay-gray-2',
    name: 'Grape - Kay Gray 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Kay Gray 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-la-crosse-2',
    name: 'Grape - La Crosse 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crosse 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-frontenac-gris-2',
    name: 'Grape - Frontenac Gris 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac Gris 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-petite-pearl-2',
    name: 'Grape - Petite Pearl 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Petite Pearl 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-itasca-2',
    name: 'Grape - Itasca 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Itasca 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-esprit-2',
    name: 'Grape - Esprit 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Esprit 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-swenson-red-2',
    name: 'Grape - Swenson Red 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Swenson Red 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-prairie-star-2',
    name: 'Grape - Prairie Star 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Prairie Star 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-saber-2',
    name: 'Grape - Saber 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saber 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-valiant-2',
    name: 'Grape - Valiant 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Valiant 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-beta-2',
    name: 'Grape - Beta 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beta 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-king-of-the-north-2',
    name: 'Grape - King of the North 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['King of the North 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-marechal-foch-2',
    name: 'Grape - Marechal Foch 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marechal Foch 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-leon-millot-2',
    name: 'Grape - Leon Millot 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Leon Millot 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-aurore-2',
    name: 'Grape - Aurore 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aurore 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-seyval-blanc-2',
    name: 'Grape - Seyval Blanc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Seyval Blanc 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-vidal-blanc-2',
    name: 'Grape - Vidal Blanc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vidal Blanc 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-chardonel-2',
    name: 'Grape - Chardonel 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chardonel 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-traminette-2',
    name: 'Grape - Traminette 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Traminette 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-vignoles-2',
    name: 'Grape - Vignoles 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vignoles 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chambourcin-2',
    name: 'Grape - Chambourcin 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chambourcin 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-noiret-2',
    name: 'Grape - Noiret 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Noiret 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-corot-noir-2',
    name: 'Grape - Corot Noir 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Corot Noir 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-arandell-2',
    name: 'Grape - Arandell 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Arandell 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-aromella-2',
    name: 'Grape - Aromella 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aromella 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-crimson-cabernet-2',
    name: 'Grape - Crimson Cabernet 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Crimson Cabernet 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-jupiter-2',
    name: 'Grape - Jupiter 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Jupiter 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-mars-2',
    name: 'Grape - Mars 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Mars 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-neptune-2',
    name: 'Grape - Neptune 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Neptune 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-reliance-2',
    name: 'Grape - Reliance 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Reliance 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-saturn-2',
    name: 'Grape - Saturn 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saturn 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-venus-2',
    name: 'Grape - Venus 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Venus 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-canadice-2',
    name: 'Grape - Canadice 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Canadice 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-einset-2',
    name: 'Grape - Einset 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Einset 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-himrod-2',
    name: 'Grape - Himrod 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Himrod 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-interlaken-2',
    name: 'Grape - Interlaken 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Interlaken 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-lakemont-2',
    name: 'Grape - Lakemont 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Lakemont 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-suffolk-red-2',
    name: 'Grape - Suffolk Red 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Suffolk Red 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-vanessa-2',
    name: 'Grape - Vanessa 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vanessa 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-marquis-2',
    name: 'Grape - Marquis 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marquis 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-glenora-2',
    name: 'Grape - Glenora 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Glenora 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-steuben-2',
    name: 'Grape - Steuben 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Steuben 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-romulus-2',
    name: 'Grape - Romulus 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Romulus 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-fredonia-2',
    name: 'Grape - Fredonia 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fredonia 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-worden-2',
    name: 'Grape - Worden 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Worden 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-sheridan-2',
    name: 'Grape - Sheridan 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sheridan 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-buffalo-2',
    name: 'Grape - Buffalo 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Buffalo 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-clinton-2',
    name: 'Grape - Clinton 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Clinton 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-elvira-2',
    name: 'Grape - Elvira 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Elvira 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-rougeon-2',
    name: 'Grape - Rougeon 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Rougeon 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-de-chaunac-2',
    name: 'Grape - De Chaunac 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['De Chaunac 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-baco-noir-2',
    name: 'Grape - Baco Noir 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Baco Noir 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chelois-2',
    name: 'Grape - Chelois 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chelois 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-chancellor-2',
    name: 'Grape - Chancellor 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chancellor 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-alicante-bouschet-2',
    name: 'Grape - Alicante Bouschet 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alicante Bouschet 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-barbera-2',
    name: 'Grape - Barbera 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Barbera 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-cabernet-franc-2',
    name: 'Grape - Cabernet Franc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Cabernet Franc 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-cabernet-sauvignon-2',
    name: 'Grape - Cabernet Sauvignon 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Cabernet Sauvignon 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-chardonnay-2',
    name: 'Grape - Chardonnay 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chardonnay 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-chenin-blanc-2',
    name: 'Grape - Chenin Blanc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chenin Blanc 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-gamay-2',
    name: 'Grape - Gamay 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Gamay 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-gewurztraminer-2',
    name: 'Grape - Gewurztraminer 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Gewurztraminer 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-grenache-2',
    name: 'Grape - Grenache 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Grenache 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-malbec-2',
    name: 'Grape - Malbec 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Malbec 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-merlot-2',
    name: 'Grape - Merlot 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Merlot 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-muscat-2',
    name: 'Grape - Muscat 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Muscat 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-petite-sirah-2',
    name: 'Grape - Petite Sirah 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Petite Sirah 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-pinot-blanc-2',
    name: 'Grape - Pinot Blanc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Blanc 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-pinot-grigio-2',
    name: 'Grape - Pinot Grigio 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Grigio 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-pinot-noir-2',
    name: 'Grape - Pinot Noir 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Pinot Noir 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-riesling-2',
    name: 'Grape - Riesling 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Riesling 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-sangiovese-2',
    name: 'Grape - Sangiovese 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sangiovese 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-sauvignon-blanc-2',
    name: 'Grape - Sauvignon Blanc 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sauvignon Blanc 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-semillon-2',
    name: 'Grape - Semillon 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Semillon 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-syrah-2',
    name: 'Grape - Syrah 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Syrah 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-tempranillo-2',
    name: 'Grape - Tempranillo 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Tempranillo 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-viognier-2',
    name: 'Grape - Viognier 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Viognier 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-zinfandel-2',
    name: 'Grape - Zinfandel 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Zinfandel 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-thompson-seedless-2',
    name: 'Grape - Thompson Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Thompson Seedless 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-flame-seedless-2',
    name: 'Grape - Flame Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Flame Seedless 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-red-globe-2',
    name: 'Grape - Red Globe 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Red Globe 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-perlette-2',
    name: 'Grape - Perlette 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Perlette 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-ruby-seedless-2',
    name: 'Grape - Ruby Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ruby Seedless 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-black-monukka-2',
    name: 'Grape - Black Monukka 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Black Monukka 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-calmeria-2',
    name: 'Grape - Calmeria 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Calmeria 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-christmas-rose-2',
    name: 'Grape - Christmas Rose 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Christmas Rose 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-emperor-2',
    name: 'Grape - Emperor 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Emperor 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-fantasy-seedless-2',
    name: 'Grape - Fantasy Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fantasy Seedless 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-holiday-2',
    name: 'Grape - Holiday 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Holiday 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-marroo-seedless-2',
    name: 'Grape - Marroo Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marroo Seedless 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-midnight-beauty-2',
    name: 'Grape - Midnight Beauty 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Midnight Beauty 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-princess-2',
    name: 'Grape - Princess 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Princess 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-scarlet-royal-2',
    name: 'Grape - Scarlet Royal 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Scarlet Royal 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-sugraone-2',
    name: 'Grape - Sugraone 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sugraone 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-sultana-2',
    name: 'Grape - Sultana 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Sultana 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-thomcord-2',
    name: 'Grape - Thomcord 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Thomcord 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-autumn-royal-2',
    name: 'Grape - Autumn Royal 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Autumn Royal 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-beauty-seedless-2',
    name: 'Grape - Beauty Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beauty Seedless 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-crimson-seedless-2',
    name: 'Grape - Crimson Seedless 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Crimson Seedless 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-fantasy-2',
    name: 'Grape - Fantasy 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Fantasy 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-flame-tokay-2',
    name: 'Grape - Flame Tokay 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Flame Tokay 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-italia-2',
    name: 'Grape - Italia 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Italia 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-olympia-2',
    name: 'Grape - Olympia 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Olympia 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-ribier-2',
    name: 'Grape - Ribier 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ribier 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-tokay-2',
    name: 'Grape - Tokay 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Tokay 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-alpenglow-2',
    name: 'Grape - Alpenglow 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alpenglow 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-alwood-2',
    name: 'Grape - Alwood 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Alwood 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-amber-2',
    name: 'Grape - Amber 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Amber 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-america-2',
    name: 'Grape - America 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['America 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-bath-2',
    name: 'Grape - Bath 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Bath 2'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-beacon-2',
    name: 'Grape - Beacon 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beacon 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-ben-hur-2',
    name: 'Grape - Ben Hur 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ben Hur 2'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-big-red-2',
    name: 'Grape - Big Red 2',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Big Red 2'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-concord-3',
    name: 'Grape - Concord 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Concord 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-niagara-3',
    name: 'Grape - Niagara 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Niagara 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-catawba-3',
    name: 'Grape - Catawba 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Catawba 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-delaware-3',
    name: 'Grape - Delaware 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Delaware 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-isabella-3',
    name: 'Grape - Isabella 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Isabella 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-ives-3',
    name: 'Grape - Ives 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Ives 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-marquette-3',
    name: 'Grape - Marquette 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marquette 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-frontenac-3',
    name: 'Grape - Frontenac 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-la-crescent-3',
    name: 'Grape - La Crescent 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crescent 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-st-croix-3',
    name: 'Grape - St Croix 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['St Croix 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-brianna-3',
    name: 'Grape - Brianna 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Brianna 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-edelweiss-3',
    name: 'Grape - Edelweiss 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Edelweiss 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-kay-gray-3',
    name: 'Grape - Kay Gray 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Kay Gray 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-la-crosse-3',
    name: 'Grape - La Crosse 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['La Crosse 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-frontenac-gris-3',
    name: 'Grape - Frontenac Gris 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Frontenac Gris 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-petite-pearl-3',
    name: 'Grape - Petite Pearl 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Petite Pearl 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-itasca-3',
    name: 'Grape - Itasca 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Itasca 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-esprit-3',
    name: 'Grape - Esprit 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Esprit 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-swenson-red-3',
    name: 'Grape - Swenson Red 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Swenson Red 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-prairie-star-3',
    name: 'Grape - Prairie Star 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Prairie Star 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-saber-3',
    name: 'Grape - Saber 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saber 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-valiant-3',
    name: 'Grape - Valiant 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Valiant 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-beta-3',
    name: 'Grape - Beta 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Beta 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-king-of-the-north-3',
    name: 'Grape - King of the North 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['King of the North 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-marechal-foch-3',
    name: 'Grape - Marechal Foch 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Marechal Foch 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-leon-millot-3',
    name: 'Grape - Leon Millot 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Leon Millot 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-aurore-3',
    name: 'Grape - Aurore 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aurore 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-seyval-blanc-3',
    name: 'Grape - Seyval Blanc 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Seyval Blanc 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-vidal-blanc-3',
    name: 'Grape - Vidal Blanc 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vidal Blanc 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-chardonel-3',
    name: 'Grape - Chardonel 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chardonel 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-traminette-3',
    name: 'Grape - Traminette 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Traminette 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-vignoles-3',
    name: 'Grape - Vignoles 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Vignoles 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-chambourcin-3',
    name: 'Grape - Chambourcin 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Chambourcin 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-noiret-3',
    name: 'Grape - Noiret 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Noiret 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-corot-noir-3',
    name: 'Grape - Corot Noir 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Corot Noir 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-arandell-3',
    name: 'Grape - Arandell 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Arandell 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-aromella-3',
    name: 'Grape - Aromella 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Aromella 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-crimson-cabernet-3',
    name: 'Grape - Crimson Cabernet 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Crimson Cabernet 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-jupiter-3',
    name: 'Grape - Jupiter 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Jupiter 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-mars-3',
    name: 'Grape - Mars 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Mars 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-neptune-3',
    name: 'Grape - Neptune 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Neptune 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-reliance-3',
    name: 'Grape - Reliance 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Reliance 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-saturn-3',
    name: 'Grape - Saturn 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Saturn 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-venus-3',
    name: 'Grape - Venus 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Venus 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-canadice-3',
    name: 'Grape - Canadice 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Canadice 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-einset-3',
    name: 'Grape - Einset 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Einset 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-himrod-3',
    name: 'Grape - Himrod 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'green table grape. Sweet and juicy, perfect for fresh eating. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Himrod 3'],
    uses: ['fresh', 'snacking']
  },
  {
    id: 'grape-interlaken-3',
    name: 'Grape - Interlaken 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'red wine grape. Classic wine grape, complex flavors. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Interlaken 3'],
    uses: ['wine', 'fermentation']
  },
  {
    id: 'grape-lakemont-3',
    name: 'Grape - Lakemont 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'purple juice grape. High juice content, excellent for processing. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Lakemont 3'],
    uses: ['juice', 'jelly', 'processing']
  },
  {
    id: 'grape-suffolk-red-3',
    name: 'Grape - Suffolk Red 3',
    scientificName: 'Vitis vinifera',
    category: 'berry',
    spacing: 96,
    rowSpacing: 96,
    daysToGermination: 0,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['blackberry', 'strawberry'],
    enemies: ['tomato'],
    description: 'black seedless grape. Convenient seedless variety for snacking. Requires trellis support.',
    hardinessZones: '4-9',
    plantingSeason: 'spring',
    height: 'vines to 20 feet',
    spread: '8-10 feet',
    family: 'Vitaceae',
    varieties: ['Suffolk Red 3'],
    uses: ['fresh', 'snacking']
  }
]
